module.exports = __webpack_public_path__ + "static/media/RED35.72627693.jpeg";